export default {"src":"/newStatic/_next/static/media/insta.65ccd67f.svg","height":20,"width":20};